import { render } from "./MmAccount.vue?vue&type=template&id=4d474827"
import script from "./MmAccount.vue?vue&type=script&lang=js"
export * from "./MmAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__